module.exports = __webpack_public_path__ + "1a01ef203e31e9a8b701ff7d4f57444e.svg";